import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px 16px;
  box-sizing: border-box;
`

export const AddZoneButton = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid var(--Border-Neutral, #bbc1d3);

  cursor: pointer;
`

export const AddZoneIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;

  svg {
    font-size: 18px;
    fill: var(--foreground-neutral-faded, #4d5874);
  }
`

export const AddZoneLabel = styled.div`
  color: var(--Foreground-Neutral-faded, #4d5874);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
